import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatInputModule } from '@angular/material/input'
import { ViaCepService } from '../../../../../core/services/address/via-cep/via-cep.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../../core/models/response.model'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ModalGoogleMapsComponent } from '../../../../address/modal-google-maps/modal-google-maps.component'
import { ItinerariesService } from '../../../../../core/services/itineraries/itineraries/itiniraries.service'
import { SnackbarCustomService } from '../../../../../shared/components/snackbar/snackbar-custom.service'
import { NgxMaskDirective } from 'ngx-mask'

@Component({
  selector: 'itineraries-item-proposal-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatOption,
    MatSelect,
    NgxMaskDirective,
  ],
  templateUrl: './itineraries-item-proposal-edit-form.component.html',
  styleUrl: './itineraries-item-proposal-edit-form.component.scss',
  providers: [ViaCepService],
  standalone: true,
})
export class ItinerariesItemProposalEditFormComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private viaCepService: ViaCepService,
    private dialogRef: MatDialogRef<ItinerariesItemProposalEditFormComponent>,
    private itinerariesService: ItinerariesService,
    private snackbar: SnackbarCustomService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data.location) {
      this.location = data.location
    }

    if (data && data.edit) {
      this.edit = true
      this.item = data.item
    }

    this.itemProposalId = data.itemProposalId
  }

  location: any = {
    cityOrigin: '',
    stateOrigin: '',
    cityDestination: '',
    stateDestination: '',
  }

  edit = false
  itemProposalId: string | number = ''
  item: any = {}
  form: FormGroup = new FormGroup({})
  loading = false

  listArea: any[] = [
    { value: 'S', description: 'Sim' },
    { value: 'N', description: 'Não' },
  ]

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}

  listType: any[] = []

  ngOnInit(): void {
    this.createForm()
    if (this.edit) {
      this.fillForm(this.item)
    }
  }

  getAddressByPostalCode() {
    const postalCode = this.form.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm(item: any) {
    this.form.get('postalCode')?.setValue(item.cep)
    this.form.get('street')?.setValue(item.logradouro)
    this.form.get('number')?.setValue(item.numero)
    this.form.get('complement')?.setValue(item.complemento)
    this.form.get('neighborhood')?.setValue(item.bairro)
    this.form.get('city')?.setValue(item.cidade)
    // this.form.get('country')?.setValue(item.pais)
    this.form.get('country')?.setValue('Brasil')
    this.form.get('state')?.setValue(item.estado)
    this.form.get('latitude')?.setValue(item.latitude)
    this.form.get('longitude')?.setValue(item.longitude)
    this.form.get('description')?.setValue(item.localParada)
    this.form.get('tariffArea')?.setValue(item.areaTarifario)
    this.form.get('horaParada')?.setValue(item.horaParada)
    this.form.get('tempoPermanencia')?.setValue(item.tempoPermanencia)
    this.form.get('atividades')?.setValue(item.atividades)
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.form.get('street')?.setValue('')
      this.form.get('number')?.setValue('')
      this.form.get('complement')?.setValue('')
      this.form.get('neighborhood')?.setValue('')
      this.form.get('city')?.setValue('')
      this.form.get('state')?.setValue('')
      this.form.get('country')?.setValue('')
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('number')?.setValue('')
      this.form.get('complement')?.setValue(element.complemento)
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
      this.form.get('country')?.setValue('Brasil')
    }
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      postalCode: [''],
      street: [''],
      neighborhood: [''],
      number: [''],
      complement: [''],
      country: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      latitude: [''],
      longitude: [''],
      tariffArea: ['N'],
      horaParada: [''],
      tempoPermanencia: [''],
      atividades: ['']
    })
    this.form.get('tariffArea')?.disable()
    this.monitoringInputs()
  }

  monitoringInputs() {
    this.form.get('state')?.valueChanges.subscribe((value) => {
      this.checkCityState()
    })
    this.form.get('city')?.valueChanges.subscribe((value) => {
      this.checkCityState()
    })
  }

  checkCityState() {
    if (
      (this.location.cityOrigin == this.form.get('city')?.value ||
        this.location.cityDestination == this.form.get('city')?.value) &&
      (this.location.stateOrigin == this.form.get('state')?.value ||
        this.location.stateDestination == this.form.get('state')?.value)
    ) {
      this.form.get('tariffArea')?.setValue('S')
    } else {
      this.form.get('tariffArea')?.setValue('N')
    }
  }

  saveItem() {
    this.loading = true
    if (this.edit) {
      this.updateItinerarie()
    } else {
      this.createItinerarie()
    }
    //   const model = this.createModel()
    // this.response.emit({ action: 'create', item: model })
    // this.resetForm()
    // this.loading = false
  }

  createItinerarie() {
    this.loading = true
    this.itinerariesService.createItineraries(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.response.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.form.reset()
      },
    })
  }

  updateItinerarie() {
    this.loading = true
    this.itinerariesService.editItineraries(this.createModel(true)).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.response.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  addTariff() {
    this.loading = true
    const model = this.createModel()
    this.response.emit(model)
    this.close()
  }

  editAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  checkForm() {
    if (this.form.valid) {
      return true
    } else {
      return false
    }
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit = false) {
    if (edit) {
      return {
        id: this.item.id,
        itemPropostaId: this.itemProposalId,
        localParada: this.form.controls['description'].value ?? '',
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        complemento: this.form.controls['complement'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude:
          this.form.get('latitude')?.value != ''
            ? this.form.get('latitude')?.value
            : null,
        longitude:
          this.form.get('longitude')?.value != ''
            ? this.form.get('longitude')?.value
            : null,
        trecho: 'P',
        areaTarifario: this.form.get('tariffArea')?.value ?? 'N',
        horaParada: this.form.get('horaParada')?.value ?? '',
        tempoPermanencia: this.form.get('tempoPermanencia')?.value ?? '',
        atividades: this.form.get('atividades')?.value ?? '',
      }
    } else {
      return {
        itemPropostaId: this.itemProposalId,
        localParada: this.form.controls['description'].value ?? '',
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        complemento: this.form.controls['complement'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
        latitude:
          this.form.get('latitude')?.value != ''
            ? this.form.get('latitude')?.value
            : null,
        longitude:
          this.form.get('longitude')?.value != ''
            ? this.form.get('longitude')?.value
            : null,
        trecho: 'P',
        areaTarifario: this.form.get('tariffArea')?.value ?? 'N',
        horaParada: this.form.get('horaParada')?.value ?? '',
        tempoPermanencia: this.form.get('tempoPermanencia')?.value ?? '',
        atividades: this.form.get('atividades')?.value ?? '',
      }
    }
  }

  googleSearch(type: 'destination' | 'origin') {
    const dialogRef = this.dialog.open(ModalGoogleMapsComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '900px',
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response.insert) {
        this.fillAdress(response.model)
      }
    })
  }

  fillAdress(model: any) {
    this.form.get('postalCode')?.setValue(model.cep)
    this.form.get('street')?.setValue(model.logradouro)
    this.form.get('number')?.setValue(model.numero)
    this.form.get('complement')?.setValue(model.complemento)
    this.form.get('neighborhood')?.setValue(model.bairro)
    this.form.get('city')?.setValue(model.cidade)
    this.form.get('state')?.setValue(model.estado)
    this.form.get('longitude')?.setValue(model.longitude)
    this.form.get('latitude')?.setValue(model.latitude)
    this.form.get('country')?.setValue(model.pais)
    this.checkCityState()
  }
}
